import styled from 'styled-components';
import { Button } from 'components';

export const PipStyled = styled(Button)`
  && {
    padding: 8px;
  }
`;
